/**
 * Create a single observer, that handles all events.
 *
 * @type {IntersectionObserver}
 */
const observer = new IntersectionObserver(
	( entries ) => {
		entries.forEach( ( entry ) => {

			// Check if entry is visible.
			if ( entry.isIntersecting && entry.target.checkVisibility() ) {
				// Fire event to handle callbacks.
				// This event does not bubble.
				entry.target.dispatchEvent( new CustomEvent( 'now_visible.sl' ) );
			}
		} );
	},
	{
		root: null,
		rootMargin: '100px 50px 250px 50px',
		threshold: 0
	}
);

/**
 * Initialize Lazy Loader that checks when elements get in view.
 *
 * @param      {any}                   targetSelector  The target selector or
 * @param      {?string}               inviewClass     The inview class
 * @param      {Function}              callback        The callback
 * @return     {IntersectionObserver}  The intersection observer.
 */
const initSimpleLazyLoadOnScroll = function( targetSelector, inviewClass, callback ) {

	const addObserver = ( targetEl ) => {
		if ( ! inviewClass || ! targetEl.classList.contains( inviewClass ) ) {
			targetEl.addEventListener( 'now_visible.sl', () => {

				// Add class to element.
				if ( inviewClass ) {
					targetEl.classList.add( inviewClass );
				}

				// Use callback if it exists and is callable.
				if ( 'function' === typeof callback ) {
					callback( targetEl );
				}

				// Remove observer from target element.
				observer.unobserve( targetEl );
			}, { once: true } );

			// Add observer.
			observer.observe( targetEl );
		}
	};

	// Observe single element or all elements via selector.
	if ( targetSelector instanceof Element ) {
		addObserver( targetSelector );
	} else if ( targetSelector instanceof NodeList || targetSelector instanceof HTMLCollection ) {
		Array.from( targetSelector ).forEach( ( targetEl ) => addObserver( targetEl ) );
	} else if ( Array.isArray( targetSelector ) ) {
		targetSelector.forEach( ( targetEl ) => {
			if ( targetEl instanceof Element ) {
				addObserver( targetEl );
			}
		} );
	} else {
		document.querySelectorAll( targetSelector ).forEach( ( targetEl ) => addObserver( targetEl ) );
	}

	return observer;
}

function initFooterBadgesLazyLoad( scopeEl = document ) {
	const footerEls = scopeEl.querySelectorAll( '.mdl_footer' );
	footerEls.forEach( footerEl => {
		initSimpleLazyLoadOnScroll( Array.from( footerEl ? footerEl.getElementsByClassName( 'lazy' ) : [] ), null, ( targetEl ) => {
			targetEl.classList.remove( 'lazy' );
		} );
	} );
}

export {
	initSimpleLazyLoadOnScroll,
	initFooterBadgesLazyLoad,
};
